export default __webpack_public_path__ + "static/nara-d58ed359d208518be1c038ad4fba0e57.png";